module.exports = __webpack_public_path__ + "img/Slide2.ee7c9a02.jpg";